import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeContext, THEMES } from "./context/ThemeContext";
import ArcaneBackground from "./components/ArcaneBackground";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Chat from "./pages/Chat";
import Vocabulary from "./pages/Vocabulary";
import BuiltBy from "./pages/BuiltBy";
import "./styles.css";

/**
 * Write all THEMES.dark / THEMES.light values to CSS custom properties
 * so that plain CSS files can reference var(--accent), var(--bg), etc.
 */
function applyThemeVars(theme) {
  const root = document.documentElement;
  const map = {
    "--bg": theme.bg,
    "--surface": theme.surface,
    "--surface-hover": theme.surfaceHover,
    "--text": theme.text,
    "--text-muted": theme.textMuted,
    "--accent": theme.accent,
    "--accent-soft": theme.accentSoft,
    "--accent2": theme.accent2,
    "--accent2-soft": theme.accent2Soft,
    "--accent3": theme.accent3,
    "--border": theme.border,
    "--nav-bg": theme.navBg,
    "--section-overlay": theme.sectionOverlay,
    "--shadow": theme.shadow,
    "--glow-gold": theme.glowGold,
    "--glow-violet": theme.glowViolet,
  };
  Object.entries(map).forEach(([k, v]) => root.style.setProperty(k, v));
}

export default function App() {
  const [isDark, setIsDark] = useState(
    () => localStorage.getItem("ai-theme") !== "light",
  );

  const theme = isDark ? THEMES.dark : THEMES.light;

  useEffect(() => {
    applyThemeVars(theme);
    localStorage.setItem("ai-theme", isDark ? "dark" : "light");
  }, [theme, isDark]);

  return (
    <ThemeContext.Provider value={{ isDark, setIsDark, theme }}>
      <BrowserRouter>
        {/* Fixed 3D canvas — sits behind all page content */}
        <ArcaneBackground isDark={isDark} />

        <Navbar />

        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/vocabulary" element={<Vocabulary />} />
            <Route path="/built-by" element={<BuiltBy />} />
          </Routes>
        </main>
      </BrowserRouter>
    </ThemeContext.Provider>
  );
}
